// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ct-ops-toolbar {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 0.85rem;
  flex-wrap: wrap;
  padding: 0 1.25rem 0.85rem;
}

.ct-ops-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 0.65rem 0.85rem;
}

.ct-ops-filter {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  font-size: 0.72rem;
  font-weight: 700;
  color: var(--text-muted);
}

.ct-ops-filter--inline {
  flex-direction: row;
  align-items: center;
  gap: 0.4rem;
}

.ct-ops-filter input,
.ct-ops-filter select {
  min-width: 160px;
  padding: 0.4rem 0.65rem;
  border: 1px solid var(--border);
  border-radius: 8px;
  font-family: inherit;
  font-size: 0.85rem;
  background: #fff;
}

.ct-ops-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.45rem;
}

.ct-ops-hint {
  margin: 0 1.25rem 0.85rem;
  font-size: 0.78rem;
  color: var(--text-muted);
  line-height: 1.45;
}

.ct-ops-sub {
  font-size: 0.72rem;
  color: var(--text-muted);
  margin-top: 0.15rem;
  font-weight: 500;
}

.ct-ops-flag {
  display: inline-flex;
  padding: 0.15rem 0.5rem;
  border-radius: 999px;
  font-size: 0.7rem;
  font-weight: 700;
  background: #ecfdf5;
  color: #047857;
}

.ct-ops-flag--on,
.ct-ops-flag--failed {
  background: #fee2e2;
  color: #b91c1c;
}

.ct-ops-flag--zero {
  background: #f1f5f9;
  color: #64748b;
}

.ct-ops-flag--completed {
  background: #ecfdf5;
  color: #047857;
}

.ct-ops-row--click {
  cursor: pointer;
}

.ct-ops-row--click:hover {
  background: #f0fdfa;
}

.ct-ops-tiles {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 0.65rem;
  padding: 0 1.25rem 1rem;
}

.ct-ops-tile {
  background: #f8fafc;
  border: 1px solid var(--border);
  border-radius: 10px;
  padding: 0.75rem 0.9rem;
}

.ct-ops-tile__label {
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--text-muted);
}

.ct-ops-tile__value {
  font-size: 1.15rem;
  font-weight: 750;
  margin-top: 0.25rem;
}

.ct-ops-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  flex-wrap: wrap;
  padding: 0.85rem 1.25rem 1.15rem;
  font-size: 0.85rem;
  color: var(--text-muted);
}

.ct-ops-pagination__right {
  display: flex;
  align-items: center;
  gap: 0.65rem;
}

.ct-ops-pagination__btns {
  display: flex;
  gap: 0.4rem;
}

.ct-ops-pagination__btns button {
  font-family: inherit;
  font-size: 0.8rem;
  font-weight: 650;
  padding: 0.4rem 0.75rem;
  border-radius: 8px;
  border: 1px solid var(--border);
  background: #fff;
}

.ct-ops-pagination__btns button:disabled {
  opacity: 0.45;
}

.copy-trading-section-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
  padding: 0 1.25rem 0.85rem;
}

.copy-trading-section-tab {
  font-family: inherit;
  font-size: 0.8rem;
  font-weight: 650;
  padding: 0.4rem 0.75rem;
  border-radius: 999px;
  border: 1px solid #e2e8f0;
  background: #fff;
  color: #64748b;
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  cursor: pointer;
  text-decoration: none;
}

.copy-trading-section-tab--active {
  background: #0f766e;
  border-color: #0f766e;
  color: #fff;
}

.copy-trading-risk-pills {
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
  margin-top: 0.35rem;
}

.copy-trading-risk-pill {
  font-size: 0.65rem;
  font-weight: 700;
  padding: 0.1rem 0.4rem;
  border-radius: 999px;
  background: #fee2e2;
  color: #b91c1c;
}

.copy-trading-modal--wide {
  max-width: 560px;
}

.copy-trading-modal__field {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  margin: 0 0 0.85rem;
  font-size: 0.75rem;
  font-weight: 700;
  color: var(--text-muted);
}

.copy-trading-modal__field input[type="text"],
.copy-trading-modal__field textarea {
  font-family: inherit;
  font-size: 0.85rem;
  font-weight: 500;
  padding: 0.5rem 0.7rem;
  border: 1px solid var(--border);
  border-radius: 8px;
  color: var(--text);
}

.copy-trading-modal__check {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  font-size: 0.82rem;
  font-weight: 500;
  color: var(--text);
  margin: 0 0 1rem;
}

.copy-trading-wind-results {
  margin: 0 0 1rem;
  padding: 0.7rem 0.8rem;
  background: #fff7ed;
  border: 1px solid #fed7aa;
  border-radius: 8px;
  font-size: 0.8rem;
  color: #9a3412;
}

.copy-trading-wind-results ul {
  margin: 0.4rem 0 0;
  padding-left: 1.1rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/CopyTrading/CopyTradingOpsPanels.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,YAAY;EACZ,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,gBAAgB;EAChB,uBAAuB;EACvB,+BAA+B;EAC/B,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,eAAe;EACf,gCAAgC;EAChC,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;;EAEE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB","sourcesContent":[".ct-ops-toolbar {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 0.85rem;\n  flex-wrap: wrap;\n  padding: 0 1.25rem 0.85rem;\n}\n\n.ct-ops-filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.65rem 0.85rem;\n}\n\n.ct-ops-filter {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  font-size: 0.72rem;\n  font-weight: 700;\n  color: var(--text-muted);\n}\n\n.ct-ops-filter--inline {\n  flex-direction: row;\n  align-items: center;\n  gap: 0.4rem;\n}\n\n.ct-ops-filter input,\n.ct-ops-filter select {\n  min-width: 160px;\n  padding: 0.4rem 0.65rem;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  font-family: inherit;\n  font-size: 0.85rem;\n  background: #fff;\n}\n\n.ct-ops-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.45rem;\n}\n\n.ct-ops-hint {\n  margin: 0 1.25rem 0.85rem;\n  font-size: 0.78rem;\n  color: var(--text-muted);\n  line-height: 1.45;\n}\n\n.ct-ops-sub {\n  font-size: 0.72rem;\n  color: var(--text-muted);\n  margin-top: 0.15rem;\n  font-weight: 500;\n}\n\n.ct-ops-flag {\n  display: inline-flex;\n  padding: 0.15rem 0.5rem;\n  border-radius: 999px;\n  font-size: 0.7rem;\n  font-weight: 700;\n  background: #ecfdf5;\n  color: #047857;\n}\n\n.ct-ops-flag--on,\n.ct-ops-flag--failed {\n  background: #fee2e2;\n  color: #b91c1c;\n}\n\n.ct-ops-flag--zero {\n  background: #f1f5f9;\n  color: #64748b;\n}\n\n.ct-ops-flag--completed {\n  background: #ecfdf5;\n  color: #047857;\n}\n\n.ct-ops-row--click {\n  cursor: pointer;\n}\n\n.ct-ops-row--click:hover {\n  background: #f0fdfa;\n}\n\n.ct-ops-tiles {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 0.65rem;\n  padding: 0 1.25rem 1rem;\n}\n\n.ct-ops-tile {\n  background: #f8fafc;\n  border: 1px solid var(--border);\n  border-radius: 10px;\n  padding: 0.75rem 0.9rem;\n}\n\n.ct-ops-tile__label {\n  font-size: 0.7rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--text-muted);\n}\n\n.ct-ops-tile__value {\n  font-size: 1.15rem;\n  font-weight: 750;\n  margin-top: 0.25rem;\n}\n\n.ct-ops-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n  padding: 0.85rem 1.25rem 1.15rem;\n  font-size: 0.85rem;\n  color: var(--text-muted);\n}\n\n.ct-ops-pagination__right {\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n}\n\n.ct-ops-pagination__btns {\n  display: flex;\n  gap: 0.4rem;\n}\n\n.ct-ops-pagination__btns button {\n  font-family: inherit;\n  font-size: 0.8rem;\n  font-weight: 650;\n  padding: 0.4rem 0.75rem;\n  border-radius: 8px;\n  border: 1px solid var(--border);\n  background: #fff;\n}\n\n.ct-ops-pagination__btns button:disabled {\n  opacity: 0.45;\n}\n\n.copy-trading-section-tabs {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem;\n  padding: 0 1.25rem 0.85rem;\n}\n\n.copy-trading-section-tab {\n  font-family: inherit;\n  font-size: 0.8rem;\n  font-weight: 650;\n  padding: 0.4rem 0.75rem;\n  border-radius: 999px;\n  border: 1px solid #e2e8f0;\n  background: #fff;\n  color: #64748b;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  cursor: pointer;\n  text-decoration: none;\n}\n\n.copy-trading-section-tab--active {\n  background: #0f766e;\n  border-color: #0f766e;\n  color: #fff;\n}\n\n.copy-trading-risk-pills {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.25rem;\n  margin-top: 0.35rem;\n}\n\n.copy-trading-risk-pill {\n  font-size: 0.65rem;\n  font-weight: 700;\n  padding: 0.1rem 0.4rem;\n  border-radius: 999px;\n  background: #fee2e2;\n  color: #b91c1c;\n}\n\n.copy-trading-modal--wide {\n  max-width: 560px;\n}\n\n.copy-trading-modal__field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n  margin: 0 0 0.85rem;\n  font-size: 0.75rem;\n  font-weight: 700;\n  color: var(--text-muted);\n}\n\n.copy-trading-modal__field input[type=\"text\"],\n.copy-trading-modal__field textarea {\n  font-family: inherit;\n  font-size: 0.85rem;\n  font-weight: 500;\n  padding: 0.5rem 0.7rem;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  color: var(--text);\n}\n\n.copy-trading-modal__check {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.5rem;\n  font-size: 0.82rem;\n  font-weight: 500;\n  color: var(--text);\n  margin: 0 0 1rem;\n}\n\n.copy-trading-wind-results {\n  margin: 0 0 1rem;\n  padding: 0.7rem 0.8rem;\n  background: #fff7ed;\n  border: 1px solid #fed7aa;\n  border-radius: 8px;\n  font-size: 0.8rem;\n  color: #9a3412;\n}\n\n.copy-trading-wind-results ul {\n  margin: 0.4rem 0 0;\n  padding-left: 1.1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
